// extracted by mini-css-extract-plugin
export default {"selectorContainer":"Selector_selectorContainer__Zd4W7","rightValue":"Selector_rightValue__UhkSN"};